import request from '@/utils/request'
// const server = "/cloudhealth-server-portal"
import Vue from 'vue'
// const server = Vue.prototype.portal
const server = "/business";

//查询患者健康资料
export function getPatientRecordData(reqParam) {
  return request({
    url: server+'/healthinfo/patientrecord/queryPatientRecords',
    method: 'get',
    params: reqParam
  })
}

//删除患者健康资料
export function deletePatientRecordData(dataId) {
  return request({
    url: server+'/healthinfo/patientrecord/deletePatientRecord',
    method: 'post',
    params: {id:dataId}
  })
}

//提交患者健康资料
export function addPatientRecordData(reqParam) {
  return request({
    url: server+'/healthinfo/patientrecord/addPatientRecords',
    method: 'post',
    data: reqParam
  })
}

//更新患者健康资料
export function updatePatientRecordData(reqParam) {
  return request({
    url: server+'/healthinfo/patientrecord/updatePatientRecords',
    method: 'post',
    data: reqParam
  })
}

//获取添加关注的诊断
export function getPatientFilterDiagnosis(reqParam) {
  return request({
    url: server+'/healthinfo/getPatientFilterDiagnosis',
    method: 'post',
    data: reqParam
  })
}

//获取添加关注的用药
export function getPatientDrugUsage(reqParam) {
  return request({
    url: server+'/healthinfo/getPatientDrugUsage',
    method: 'post',
    data: reqParam
  })
}

//患者体检信息列表
export function getPatientPysicalExamList(reqParam) {
  return request({
    url: server+'/healthinfo/getPatientPysicalExamList',
    method: 'post',
    data: reqParam
  })
}

//患者体检项目详情
export function getPatientPysicalExamDetail(reqId) {
  return request({
    url: server+'/healthinfo/getPatientPysicalExamDetail',
    method: 'get',
    params: {examId:reqId}
  })
}

//患者门诊信息列表
export function getPatientVisits(reqParam) {
  return request({
    url: server+'/healthinfo/getPatientVisits',
    method: 'post',
    data: reqParam
  })
}

//住院信息列表
export function getPatientInpatients(reqParam) {
  return request({
    url: server+'/healthinfo/getPatientInpatients',
    method: 'post',
    data: reqParam
  })
}

//患者检验列表
export function getTestReports(reqParam) {
  return request({
    url: server+'/healthinfo/getTestReports',
    method: 'post',
    data: reqParam
  })
}

//详细住院信息
export function getPatientInpatientDetail(reqId) {
  return request({
    url: server+'/healthinfo/getPatientInpatientDetail',
    method: 'get',
    params: {id:reqId}
  })
}

//详细住院医嘱
export function getInpatientCpoeInfo(reqParam) {
  return request({
    url: server+'/healthinfo/getInpatientCpoeInfo',
    method: 'get',
    params: reqParam
  })
}

//详细门诊信息
export function getPatientVisitDetail(reqId) {
  return request({
    url: server+'/healthinfo/getPatientVisitDetail',
    method: 'get',
    params: {id:reqId}
  })
}

//详细门诊医嘱
export function getOutpatientCpoeInfo(reqParam) {
  return request({
    url: server+'/healthinfo/getOutpatientCpoeInfo',
    method: 'get',
    params: reqParam
  })
}

//患者检验列表
export function getPatientDiagnosis(reqParam) {
  return request({
    url: server+'/healthinfo/getPatientDiagnosis',
    method: 'post',
    data: reqParam
  })
}

//详细门诊医嘱
export function getDiagItems(reqParam) {
  return request({
    url: server+'/healthinfo/getDiagItems',
    method: 'post',
    data: reqParam
  })
}

//住院信息列表
export function addPersonalDiags(reqParam) {
  return request({
    url: server+'/healthinfo/addPersonalDiags',
    method: 'post',
    data: reqParam
  })
}

//添加患者用药
export function addPersonalMedicines(reqParam) {
  return request({
    url: server+'/healthinfo/addPersonalMedicines',
    method: 'post',
    data: reqParam
  })
}

//创建患者诊断
export function createPersonalDiag(reqParam) {
  return request({
    url: server+'/healthinfo/createPersonalDiag',
    method: 'post',
    data: reqParam
  })
}

//创建患者用药
export function createPersonalMedicine(reqParam) {
  return request({
    url: server+'/healthinfo/createPersonalMedicine',
    method: 'post',
    data: reqParam
  })
}

//编辑患者用药
export function updatePersonalMedicine(reqParam) {
  return request({
    url: server+'/healthinfo/updatePersonalMedicine',
    method: 'post',
    data: reqParam
  })
}

//编辑患者诊断
export function updatePersonalDiag(reqParam) {
  return request({
    url: server+'/healthinfo/updatePersonalDiag',
    method: 'post',
    data: reqParam
  })
}

//获取问卷列表
export function getVoteList(reqParam) {
  return request({
    url: server+'/healthinfo/vote/user/getVoteAnswerList',
    method: 'post',
    data: reqParam
  })
}

//添加问卷
export function addVote(reqParam) {
  return request({
    url: server+'/healthinfo/vote/user/addVoteAnswer',
    method: 'post',
    data: reqParam
  })
}

//删除问卷
export function deleteVote(reqParam) {
  return request({
    url: server+'/healthinfo/vote/user/deleteVoteAnswer',
    method: 'post',
    data: reqParam
  })
}

